export default __webpack_public_path__ + "static/ctaModule_cloud_top_mobile-47b1a4c0b2ee054c7b4ae2724a487d01.png";